import { render, staticRenderFns } from "./key-value-box.vue?vue&type=template&id=5901db3f&scoped=true&"
import script from "./key-value-box.vue?vue&type=script&lang=js&"
export * from "./key-value-box.vue?vue&type=script&lang=js&"
import style0 from "./key-value-box.vue?vue&type=style&index=0&id=5901db3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901db3f",
  null
  
)

export default component.exports